import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import type { IGetlocalizedMessage } from 'src/interfaces/gas-price.model';
import type { INetworksResponse, IHandleNetworkChange } from 'src/interfaces/network.model';
import { updateUrlParam } from '../../helpers/updateUrlParams';
import { Network } from '../network/Network';

interface NetworkListProps {
  networksData: INetworksResponse | null;
  loading: boolean;
  currentNetwork: string | null;
  handleNetworkChange: IHandleNetworkChange;
  isTimerEnd: boolean;
  localizedMessage: IGetlocalizedMessage;
}

export function NetworkList({ networksData, loading, currentNetwork, handleNetworkChange, isTimerEnd, localizedMessage }: NetworkListProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const networkFromUrl = searchParams.get('networkId');
  const [activeNetwork, setActiveNetwork] = useState<string | null>(currentNetwork);

  useEffect(() => {
    if (networkFromUrl != null) {
      setActiveNetwork(networkFromUrl);
      handleNetworkChange(networkFromUrl);
    } else if (!activeNetwork && networksData?.networks.length) {
      const firstNetworkId = networksData.networks[0].nameId;
      setActiveNetwork(firstNetworkId);
      handleNetworkChange(firstNetworkId);
      updateUrlParam('networkId', firstNetworkId, navigate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkFromUrl, networksData, handleNetworkChange, navigate]);

  return (
    <>
      <h4 className="calculator__network-header">{loading || !isTimerEnd ? <Skeleton /> : localizedMessage('calculator__choosing-network')}</h4>

      <div className="calculator__content--network" id="networks-container">
        {loading || !isTimerEnd ? (
          <Skeleton count={6} containerClassName="skeleton__networks-container" inline width={165} className="skeleton__networks" height={48} borderRadius={10} />
        ) : (
          networksData?.networks.map((item) => (
            <Network
              key={item.nameId}
              network={item}
              isActive={activeNetwork === item.nameId}
              onNetworkClick={() => {
                setActiveNetwork(item.nameId);
                handleNetworkChange(item.nameId);
                const newSearchParams = new URLSearchParams();
                newSearchParams.set('networkId', item.nameId);
                navigate({ search: `?${newSearchParams.toString()}` }, { replace: true });
              }}
            />
          ))
        )}
      </div>
    </>
  );
}
